import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RecaptchaState {
    key: string;
    token?: string;
    timer?: number;
    active: boolean;
    canUseContactForm?: boolean;
    canUploadFile: boolean;
}

const initialState: RecaptchaState = {
    key: '',
    active: false,
    canUseContactForm: undefined,
    canUploadFile: false
};

export const recaptchaSlice = createSlice({
    name: 'recaptcha',
    initialState,
    reducers: {
        clear(state) {
            state.token = undefined;
        },
        updateToken(state, action: PayloadAction<string>) {
            state.token = action.payload;
        },
        setKey(state, action: PayloadAction<string>) {
            state.key = action.payload;
        },
        setAuthorisations(state, action: PayloadAction<{ canUseContactForm: boolean, canUploadFile: boolean; }>) {
            state.canUseContactForm = action.payload.canUseContactForm;
            state.canUploadFile = action.payload.canUploadFile;
        },
        setTimer(state, action: PayloadAction<number | undefined>) {
            state.timer = action.payload;
        },
        setActive(state, action: PayloadAction<boolean>) {
            state.active = action.payload;
        },
    }
});
